import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  DataLayerStyleEditModalContainer, type DataLayerStyleEditModalProps,
} from './dataLayerStyleEditModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    DataLayerStyleEdit: DataLayerStyleEditModalProps;
  }
}

modalRenderer.register('DataLayerStyleEdit', DataLayerStyleEditModalContainer);
